import { render, staticRenderFns } from "./personalWalletModal.vue?vue&type=template&id=668c303e"
import script from "./personalWalletModal.vue?vue&type=script&lang=js"
export * from "./personalWalletModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports